import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  Signal,
  TemplateRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgTemplateOutlet } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Store } from '@ngrx/store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AppState } from '../../store/app.state';
import { userSettingsFeature } from '../../store/state/user-settings/user-settings.feature';
import { TranslatePipe } from '@ngx-translate/core';
import {
  PageHeaderAction,
  PageHeaderService,
  UiButtonComponent,
  UiHeaderWithBreadcrumbsComponent,
  UiRefreshButtonComponent,
  ViewportService,
} from '@ui';
import { routeFeature } from '../../store/state/route/route.feature';
import { async, Observable } from 'rxjs';
import { RouteModels } from '@share-models';
import { AsyncPipe, NgIf } from '@angular/common';
import { HeaderActionsService } from '../../services/header-actions.service';
import { MobileHeaderOutletComponent } from '../mobile-header-outlet/mobile-header-outlet.component';
import { MobileBottomBarComponent } from '../mobile-bottom-bar/mobile-bottom-bar.component';
import { MobileStatusBarService } from '../../services/mobile-status-bar.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  imports: [RouterOutlet, SidebarComponent, UiHeaderWithBreadcrumbsComponent, AsyncPipe, NgIf, NgTemplateOutlet, MobileHeaderOutletComponent, MobileBottomBarComponent, UiRefreshButtonComponent, UiButtonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly store = inject(Store<AppState>);
  private readonly headerActionsService = inject(HeaderActionsService);
  private readonly pageHeaderService = inject(PageHeaderService);
  public readonly viewportService: ViewportService = inject(ViewportService);
  private readonly mobileStatusBar = inject(MobileStatusBarService);

  public readonly headerActionsTemplate: Signal<TemplateRef<unknown> | null> =
    this.headerActionsService.template;

  public readonly pageActions: Signal<PageHeaderAction[]> =
    this.pageHeaderService.actions;

  private readonly darkThemeClassName = 'dark-theme';
  private readonly lightThemeClassName = 'light-theme';

  public searchQuery = '';

  public selectBreadcrumbs$: Observable<RouteModels.UiBreadCrumbItem[] | null> = this.store.select(routeFeature.selectBreadcrumbs);

  public ngOnInit(): void {
    this.store
      .select(userSettingsFeature.selectTheme)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => {
        this.syncBodyTheme(theme);
      });


  }

  private syncBodyTheme(theme: 'light' | 'dark'): void {
    const isDarkTheme = theme === 'dark';
    document.body.classList.toggle(this.darkThemeClassName, isDarkTheme);
    document.body.classList.toggle(this.lightThemeClassName, !isDarkTheme);
    void this.mobileStatusBar.setTheme(isDarkTheme ? 'light' : 'dark');
  }

  protected readonly async = async;
}
